import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TextMaskModule } from 'angular2-text-mask';
import { Daterangepicker } from 'ng2-daterangepicker';
import { CovidDashboardComponent } from './covid-dashboard/covid-dashboard.component';
import { CovidFormComponent } from './covid-form/covid-form.component';
import { CovidQuestPopupComponent } from './covid-quest-popup/covid-quest-popup.component';
import { CovidComponent } from './covid.component';

const routes: Routes = [
    {
        path: 'results',
        component: CovidComponent,
    },
];

@NgModule({
    declarations: [CovidComponent, CovidDashboardComponent, CovidQuestPopupComponent, CovidFormComponent],
    imports: [
        CommonModule,
        NgbModule,
        FormsModule,
        TextMaskModule,
        Daterangepicker,
        RouterModule.forChild(routes),
        NgSelectModule,
        ReactiveFormsModule,
    ],
    exports: [CovidComponent, CovidDashboardComponent],
})
export class CovidModule {}
